import { useEffect, useState } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/context/LanguageContext";

import Loader from "@/components/site/Loader";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import About from "@/components/site/About";
import Story from "@/components/site/Story";
import WhyChoose from "@/components/site/WhyChoose";
import Products from "@/components/site/Products";
import Markets from "@/components/site/Markets";
import Stats from "@/components/site/Stats";
import MissionVision from "@/components/site/MissionVision";
import Manifesto from "@/components/site/Manifesto";
import CoreValues from "@/components/site/CoreValues";
import Faq from "@/components/site/Faq";
import Contact from "@/components/site/Contact";
import WhatsAppFloat from "@/components/site/WhatsAppFloat";
import Footer from "@/components/site/Footer";

function AppContent() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    let lenis;
    if (!reduce) {
      lenis = new Lenis({ duration: 1.15, smoothWheel: true, lerp: 0.09 });
      const raf = (time) => {
        lenis.raf(time);
        requestAnimationFrame(raf);
      };
      requestAnimationFrame(raf);
    }
    const t = setTimeout(() => setLoading(false), 1400);
    return () => {
      clearTimeout(t);
      if (lenis) lenis.destroy();
    };
  }, []);

  return (
    <div className="App bg-[#f8fff8] text-[#222222] font-body antialiased">
      <Loader show={loading} />
      <Toaster position="top-center" richColors />
      <Navbar />
      <main>
        <Hero />
        <About />
        <Story />
        <WhyChoose />
        <Products />
        <Markets />
        <Stats />
        <MissionVision />
        <Manifesto />
        <CoreValues />
        <Faq />
        <Contact />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}

function App() {
  return (
    <LanguageProvider>
      <AppContent />
    </LanguageProvider>
  );
}

export default App;
